export default class OrderTracking {
  carrier?: string;
  deliveredDate?: Date;
  estimateDate?: string;
  number?: string;
  shippedDate?: Date;
  url?: string;
}
